import React from 'react'
import Restaurant from './component/basics/Restaurant'

const App = () => {
  return <Restaurant/>
}

export default App
